<!--
/**
* @name: Add.vue
* @description: 添加优惠券页面
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :title="isEdit ? '编辑优惠券' : isView ? '查看优惠券' : '新增优惠券'" :loading="isLoading">
    <template v-if="!isView">
      <y-form titleAlign="right" titleWidth="100px" contentWidth="550px">
        <y-form-item title="销售渠道:" required>
          <k-select clearable block v-model="editPara.saleChannelCode" :class="css.inputW">
            <k-option v-for="item in channelList" :key="item.code" :selected="editPara.saleChannelCode == item.code"
                      :value="item.code" :label="item.name">{{ item.name }}</k-option>
          </k-select>
        </y-form-item>
        <y-form-item title="推广渠道:" required>
          <div>
            <k-radio v-model="editPara.promoteChannel" @change="changeType" value="C_CLIENT">C端</k-radio>
            <k-radio v-model="editPara.promoteChannel" @change="changeType" value="B_CLIENT">门店</k-radio>
            <k-radio v-model="editPara.promoteChannel" @change="changeType" value="VALET">代客下单 <tool-tip size="13px"
                        icon="k-icon-tip" direction="top" tipValue="仅门店代客下单时可用" width="166"></tool-tip>
            </k-radio>
          </div>
        </y-form-item>
        <y-form-item title="适用场景:" required>
          <div>
            <k-radio v-for="(item, index) in suitSceneList" :key="index" v-model="editPara.suitScene"
                     :value="item.value">{{ item.name }}</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="场景活动编号:" required v-if="editPara.suitScene == 'live'">
          <k-input style="width: 140px;" placeholder="请输入场景活动编号" block v-model="editPara.suitSceneNo"></k-input>
        </y-form-item>
        <y-form-item title="优惠券名称:" required>
          <k-input :class="css.inputW" placeholder="请输入优惠额度，例如XXX优惠券，不超过20个字。" block clearable
                   v-model="editPara.bonusName" v-validate="'required'" maxlength="20"></k-input>
        </y-form-item>
        <y-form-item title="面值:" required>
          <k-input @keydown.native="clearInput" style="width: 120px;" placeholder="请输入面值" type="number" min="0" block
                   v-model="editPara.bonusValue"></k-input>
        </y-form-item>
        <y-form-item title="发放方式:" required>
          <div>
            <k-radio v-model="editPara.provideType" value="ASSIGN">定向发放</k-radio>
            <k-radio v-model="editPara.provideType" value="EXCHANGE">兑换码</k-radio>
            <k-radio v-model="editPara.provideType" value="ONLINE">线上领取</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="领取次数:" required v-if="editPara.provideType == 'ONLINE'">
          <div>
            <k-radio v-model="limit" :value="-1">不限制</k-radio>
            <k-radio v-model="limit" :value="1">限制</k-radio>
            <k-input-number class="ml-1" :disabled="limit == 1 ? false : true"
                            v-model="editPara.receiveLimit"></k-input-number>
          </div>
        </y-form-item>
        <y-form-item title="可用金额限制:" required align="top">
          <div>
            <k-radio v-model="editPara.haveThreshold" :value="1">限制</k-radio>
            <k-radio v-model="editPara.haveThreshold" :value="0">不限制</k-radio>
          </div>
          <div class="mt-1" v-if="editPara.haveThreshold == '1'">
            <k-input @keydown.native="clearInput" style="width: 120px;" placeholder="请输入限制金额，最多两位小数" type="number"
                     min="0" block v-model="editPara.thresholdValue"></k-input>
          </div>
        </y-form-item>
        <y-form-item title="优惠承担方:" required align="top">
          <div :class="css.box">
            <k-radio v-model="editPara.bear" value="PLATFORM">平台</k-radio>
            <k-radio v-model="editPara.bear" value="SUPPLIER">供应商</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="使用范围:" required>
          <div>
            <k-radio v-model="editPara.suitScopeType" value="GOODS">商品</k-radio>
            <k-radio v-model="editPara.suitScopeType" value="CATEGORY"
                     :disabled="editPara.bear == 'SUPPLIER' ? true : false">分类</k-radio>
            <k-radio v-model="editPara.suitScopeType" value="BRAND"
                     :disabled="editPara.bear == 'SUPPLIER' ? true : false">品牌</k-radio>
          </div>
        </y-form-item>
        <y-form-item v-if="editPara.suitScopeType == 'GOODS'" title="商品货号:" required>
          <div :class="css.flex">
            <k-input style="width: 280px;" placeholder="请输入商品货号，用英文逗号隔开" clearable v-model="goodsSns"></k-input>
            <a @click="addGoodsSns">添加</a>
          </div>
        </y-form-item>
        <k-table has-index max-height="300px" :data="goodsSnsList" :rightFixedNumber="1" :class="css.tableW"
                 :columns="goodsSnsColumns()"
                 v-if="this.goodsSnsList.length > 0 && editPara.suitScopeType == 'GOODS'"></k-table>
        <y-form-item v-show="editPara.suitScopeType == 'BRAND'" title="选择品牌:" required>
          <k-select2 v-model="brandIds" :class="css.inputW" :data="brandList" search-field="gbname" text-field="gbname"
                     key-field="gbcode" layer-width="auto" layerMinWidthEqual :nearby="true" placeholder="请选择商品品牌"
                     ref="selectBrand">
          </k-select2>
        </y-form-item>
        <y-form-item v-show="editPara.suitScopeType == 'CATEGORY'" title="选择分类:" required>
          <k-select2 v-model="catIds" :class="css.inputW" :data="catList" search-field="name" text-field="parentNameUrl"
                     key-field="id" layer-width="auto" layerMinWidthEqual :nearby="true" placeholder="请选择商品分类"
                     ref="selectCat">
          </k-select2>
        </y-form-item>
        <y-form-item v-if="editPara.bear == 'SUPPLIER'" title="适用批次号:" required>
          <k-select2 v-model="saleBatchNoList" :class="css.inputW" :data="batchList" search-field="code"
                     text-field="code" key-field="code" layer-width="auto" layerMinWidthEqual :nearby="true"
                     placeholder="请选择适用批次号" ref="selectBatch">
          </k-select2>
        </y-form-item>
        <y-form-item title="使用有效期:" required>
          <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="effectDate"
                      format="yyyy-MM-dd HH:mm:ss" placeholder="请选择使用有效期" style="width: 280px;"></DatePicker>
        </y-form-item>
        <y-form-item title="发放总数量:" required>
          <k-input-number v-model="editPara.bonusNumber"></k-input-number>
        </y-form-item>
        <y-form-item title="备注:" align="top">
          <k-input tag="textarea" :class="css.textarea" v-model="editPara.remark" block
                   placeholder="关于优惠券的补充信息"></k-input>
        </y-form-item>
      </y-form>
    </template>
    <template v-else>
      <y-form titleAlign="right" titleWidth="100px" contentWidth="550px">
        <y-form-item title="销售渠道:" required clearable>
          <span>{{ editPara.saleChannelCode | filterChannel(this.channelList) }}</span>
        </y-form-item>
        <y-form-item title="推广渠道:" required>
          <span>{{ editPara.promoteChannel == "C_CLIENT" ? "C端" : editPara.promoteChannel == "VALET" ? "代客下单" : "门店"
}}</span>
        </y-form-item>
        <y-form-item title="适用场景:" required>
          <span>{{ editPara.suitScene == "live" ? "直播" : "普通" }}</span>
        </y-form-item>
        <y-form-item title="场景活动编号:" required v-if="editPara.suitScene == 'live'">
          <span>{{ editPara.suitSceneNo }}</span>
        </y-form-item>
        <y-form-item title="优惠券名称:" required>
          <span>{{ editPara.bonusName }}</span>
        </y-form-item>
        <y-form-item title="面值:" required>
          <span>{{ editPara.bonusValue }}</span>
        </y-form-item>
        <y-form-item title="发放方式:" required>
          <span v-if="editPara.provideType == 'ASSIGN'">定向发放</span>
          <span v-if="editPara.provideType == 'EXCHANGE'">兑换码</span>
          <span v-if="editPara.provideType == 'ONLINE'">线上领取</span>
        </y-form-item>
        <y-form-item title="领取次数:" required v-if="editPara.provideType == 'ONLINE'">
          <div>
            <span v-if="limit == -1">不限制</span>
            <span v-if="limit == 1">限制</span>
            <span class="ml-1" v-if="limit == 1">{{ editPara.receiveLimit }} 次</span>
          </div>
        </y-form-item>
        <y-form-item title="可用金额限制:" required align="top">
          <div>
            <span v-if="editPara.haveThreshold == 0">不限制</span>
            <span v-if="editPara.haveThreshold == 1">限制</span>
            <span class="ml-1" v-if="editPara.haveThreshold == 1">满{{ editPara.thresholdValue }}可用</span>
          </div>
        </y-form-item>
        <y-form-item title="使用范围:" required>
          <span v-if="editPara.suitScopeType == 'GOODS'">商品</span>
          <span v-if="editPara.suitScopeType == 'CATEGORY'">分类</span>
          <span v-if="editPara.suitScopeType == 'BRAND'">品牌</span>
        </y-form-item>
        <y-form-item v-if="editPara.suitScopeType == 'GOODS'" title="商品货号:" required>
          <span>{{ goodsSns }}</span>
        </y-form-item>
        <k-table has-index max-height="300px" :data="goodsSnsList" :rightFixedNumber="1"
                 :columns="goodsSnsColumns().splice(0, 2)" :class="css.tableW"
                 v-if="this.goodsSnsList.length > 0 && editPara.suitScopeType == 'GOODS'"></k-table>
        <y-form-item v-if="editPara.suitScopeType == 'BRAND'" title="选择品牌:" required>
          <span>{{ brandIds | filterBrand(this.brandList) }}</span>
        </y-form-item>
        <y-form-item v-if="editPara.suitScopeType == 'CATEGORY'" title="选择分类:" required>
          <span>{{ catIds | filterCat(this.catList) }}</span>
        </y-form-item>
        <y-form-item v-if="editPara.bear == 'SUPPLIER'" title="适用批次号:" required>
          <span>{{ saleBatchNoList | filterBatch(this.batchList) }}</span>
        </y-form-item>
        <y-form-item title="使用有效期:" required>
          <span>{{ editPara.useStartTime }}~{{ editPara.useEndTime }}</span>
        </y-form-item>
        <y-form-item title="发放总数量:" required>
          <span>{{ editPara.bonusNumber }} 张</span>
        </y-form-item>
        <y-form-item title="优惠承担方:" required align="top">
          <div :class="css.box">
            <span v-if="editPara.bear == 'PLATFORM'">平台</span>
            <span v-if="editPara.bear == 'SUPPLIER'">供应商</span>
          </div>
        </y-form-item>
        <y-form-item title="备注:" align="top">
          <span>{{ editPara.remark }}</span>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MARKETING_BACK_SERVER_BONUS_SAVE,
  NESTLE_MARKETING_BACK_SERVER_BONUS_UPDATE,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_MARKETING_BACK_SERVER_BONUS_DETAIL,
  NESTLE_MARKETING_BACK_SERVER_BONUS_SALE_BATCH_NO_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
} from "@/assets/modules/apiList";

const initEditPara = () => ({
  saleChannelCode: "", //销售渠道
  promoteChannel: "", //推广渠道
  bonusName: "", //优惠券名称
  bonusValue: "", //优惠券面值
  haveThreshold: null, //可用金额限制
  thresholdValue: "", //可用金额限制值
  suitScopeType: "", //使用范围
  suitResourceList: [],
  provideType: "", //发放方式
  suitScene: "", //适用场景
  receiveLimit: "",
  suitSceneNo: "",
  useStartTime: "",
  useEndTime: "",
  bonusNumber: "",
  remark: "",
  bear: "",
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isEdit: false,
      isView: false,
      suitSceneList: [],
      limit: 0,
      editPara: initEditPara(),
      effectDate: [],
      brandList: [], //品牌列表
      originData: {},
      brandIds: [], //品牌ID
      saleBatchNoList: [],
      goodsSns: "",
      goodsSnsList: [],
      catList: [], //分类列表
      batchList: [],//批次
      codeBatchList: [],//批次-货号

      catIds: [], //分类ID
      channelList: [],
      show: false,
    };
  },
  filters: {
    filterChannel(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.code) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filterBrand(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code.indexOf(a.gbcode) != -1) {
          tmp.push(a.gbname);
        }
      });
      return tmp.join(",");
    },
    filterCat(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code.indexOf(a.id + "") != -1) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filterBatch(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code.indexOf(a.code + "") != -1) {
          tmp.push(a.code);
        }
      });
      return tmp.join(",");
    },
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        if (
          !para.saleChannelCode ||
          !para.promoteChannel ||
          !para.bonusName ||
          !para.bonusValue ||
          !para.provideType ||
          (para.provideType == "ONLINE" && this.limit == "") ||
          (para.provideType == "ONLINE" && this.limit == 1 && !para.receiveLimit) ||
          (!para.haveThreshold && para.haveThreshold != 0) ||
          (para.haveThreshold == "1" && !para.thresholdValue) ||
          !para.suitScene ||
          (para.suitScene == "live" && !para.suitSceneNo) ||
          !this.effectDate ||
          !para.bear ||
          !para.bonusNumber ||
          !para.suitScopeType ||
          (para.bear == "SUPPLIER" && this.saleBatchNoList && this.saleBatchNoList.length === 0) ||
          (para.suitScopeType == "GOODS" && this.goodsSnsList.length === 0) ||
          (para.suitScopeType == "BRAND" && this.brandIds && this.brandIds.length === 0) ||
          (para.suitScopeType == "CATEGORY" && this.catIds && this.catIds.length === 0)
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    "editPara.suitScopeType": {
      handler(newValue) {
        if (newValue != "BRAND" && newValue != "" && !this.isView) {
          this.$refs.selectBrand.searchText = "";
        }
        if (newValue != "CATEGORY" && newValue != "" && !this.isView) {
          this.$refs.selectCat.searchText = "";
        }
      },
      immediate: true,
    },
    "editPara.provideType": {
      handler(newValue) {
        if (newValue != "ONLINE") {
          this.limit = "";
          this.editPara.receiveLimit = "";
        }
      },
      immediate: true,
    },
    "editPara.haveThreshold": {
      handler(newValue) {
        if (newValue == 0) {
          this.editPara.thresholdValue = "";
        }
      },
      immediate: true,
    },
    limit: function (newValue) {
      if (newValue == -1) {
        this.editPara.receiveLimit = "";
      }
    },
    goodsSnsList: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (this.editPara.bear == "SUPPLIER") {
            this.getBatchList(newValue.map((v) => v.goodsCodeSale));
          }
        }
      },
      immediate: true,
    },
    batchList: {
      handler(newValue) {
        if (newValue && newValue.length === 0) {
          this.saleBatchNoList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    onDeleteGoods(row) {
      this.$dialog({
        title: "提示",
        content: "确认删除当前商品吗？",
        ok: () => {
          for (let index = 0; index < this.goodsSnsList.length; index++) {
            if (this.goodsSnsList[index].id == row.id) {
              this.goodsSnsList.splice(index, 1);
              break;
            }
          }
        },
      });
    },
    addGoodsSns() {
      let { tip } = this.$root;
      if (!this.goodsSns) {
        return tip("请输入商品货号");
      }
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
        para: { goodsCodeSaleList: this.goodsSns.split(",") },
      }).then((res) => {
        if (res) {
          let msg = "";
          let Arr = [];
          res.forEach((v) => {
            // 判断该商品是否已被添加过
            if (this.goodsSnsList.map((y) => y.goodsCodeSale).indexOf(v.goodsCodeSale) < 0) {
              if (this.goodsSnsList.length < 50) {
                this.goodsSnsList.push(v);
              } else {
                msg = "最多只能添加50个商品";
              }
            } else {
              Arr.push(v.goodsCodeSale);
              msg = `${Arr}商品已被选择`;
            }
          });
          // 输入多个商品货号 某几个不正确
          if (res.length !== new Set(this.goodsSns.split(",")).size) {
            const arr = this.goodsSns.split(",").filter((item) => !res.map((y) => y.goodsCodeSale).includes(item));
            msg = `添加失败！商品货号${arr}在系统不存在`;
          }
          if (msg) return tip(msg);
          this.goodsSns = "";
        } else {
          // 输入一个商品货号 且货号不存在
          return tip("该商品货号不存在，请输入正确的商品货号");
        }
      });
    },
    goodsSnsColumns() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "操作",
          field: "action",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
          },
          customRender: (row) => {
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDeleteGoods(row);
                }}
              >
                删除
              </a>
            );
            return <div>{deleteButton}</div>;
          },
        },
      ];
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    changeType(e) {
      this.editPara.provideType = "";
    },
    changeDate(date) {
      this.effectDate = date;
    },
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {},
      }).then((res) => {
        this.brandList = res;
      });
    },
    getBatchList(params) {
      console.log('params', params);
      this.$fetch({
        // api: NESTLE_MARKETING_BACK_SERVER_BONUS_SALE_BATCH_NO_LIST,
        api: '/nestle-marketing-back-server/bonus/sale/batch/no/list_by_goods_list',
        // para: { goodsCodeSale: params },
        para: { goodsCodeSaleList: params }
      }).then((res) => {
        let data = [];
        for (let i = 0; i < res.length; i++) {
          data.push({ ...res[i], code: res[i].goodsCodeSale + '-' + res[i].saleBatchNo });
        }
        this.batchList = data;
        console.log('data', data);
        // codeBatchList
      });
    },
    getCatList() {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
        para: { isEnabled: true, rank: 3 },
      }).then((res) => {
        this.catList = res;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "couponManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    //获取适应场景
    getSuitSceneList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "APPLICABLE_SCENE",
        },
      }).then((res) => {
        this.suitSceneList = res || [];
      });
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let reg = /^\d+(\.\d{1,2})?$/;
      if (this.editPara.haveThreshold == "1" && this.editPara.thresholdValue.toString().slice(0, 1) == "0" && this.editPara.thresholdValue.toString().slice(1, 1) != ".") {
        return tip("可用金额限制输入非小数时，首位不可以为0");
      }
      if (this.editPara.haveThreshold == "1" && !reg.test(this.editPara.thresholdValue)) {
        return tip("可用金额限制只能输入正数数字，0不可以；特殊字符不可以；最多2位小数");
      }
      if (this.editPara.bonusValue.toString().slice(0, 1) == "0" && this.editPara.bonusValue.toString().slice(1, 1) != ".") {
        return tip("面值输入非小数时，首位不可以为0");
      }
      if (!reg.test(this.editPara.bonusValue)) {
        return tip("面值只能输入正数数字，0不可以；特殊字符不可以；最多2位小数");
      }
      if (this.limit == 1 && this.editPara.receiveLimit > this.editPara.bonusNumber) {
        return tip("领取次数不能大于发送总数量");
      }
      if (new Date(this.effectDate[1]) - new Date() < 0) {
        return tip("结束日期不能小于当前时间");
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (para.suitScene == "common") {
        para.suitSceneNo = "";
      }
      para.useStartTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : "";
      para.useEndTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : "";
      para.receiveLimit = this.limit == -1 ? -1 : para.receiveLimit;
      if (para.suitScopeType == "CATEGORY") {
        para.suitResourceList = this.catIds;
      } else if (para.suitScopeType == "BRAND") {
        para.suitResourceList = this.brandIds;
      } else if (para.suitScopeType == "GOODS") {
        if (this.goodsSnsList.length > 0) {
          if (this.goodsSnsList.length > 50) {
            return tip("该优惠券最多只能应用于50个商品");
          }
          let arr = [];
          this.goodsSnsList.forEach((v) => {
            arr.push(v.goodsCodeSale);
          });
          para.suitResourceList = arr;
        }
      }
      if (this.editPara.bear == "SUPPLIER") {
        para.saleBatchNoList = this.saleBatchNoList;
      }
      let d = []
      this.batchList.forEach(it => {
        if (this.saleBatchNoList.indexOf(it.code) > -1) {
          console.log('it', it);
          d.push({ goodsCodeSale: it.goodsCodeSale, saleBatchNo: it.saleBatchNo })
        }
      })
      console.log('d', d);

      para.supplierSaleBatchNoList = d

      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MARKETING_BACK_SERVER_BONUS_UPDATE : NESTLE_MARKETING_BACK_SERVER_BONUS_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    getCouponDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_DETAIL,
        para: { id: id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.effectDate = [this.editPara.useStartTime, this.editPara.useEndTime];
          if (this.editPara.provideType == "ONLINE" && this.editPara.receiveLimit == -1) {
            this.limit = -1;
          } else if (this.editPara.provideType == "ONLINE" && this.editPara.receiveLimit != -1) {
            this.limit = 1;
          }
          let suitResourceList = [];
          for (let i = 0; i < this.editPara.bonusSuitVOList.length; i++) {
            suitResourceList.push(this.editPara.bonusSuitVOList[i].suitResource);
          }
          this.editPara.suitResourceList = suitResourceList;
          if (this.editPara.suitScopeType == "GOODS") {
            this.goodsSns = "";
            this.$fetch({
              api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
              para: { goodsCodeSaleList: suitResourceList.join(",").split(",") },
            }).then((i) => {
              this.goodsSnsList = i;
            });
          } else if (this.editPara.suitScopeType == "CATEGORY") {
            this.catIds = suitResourceList;
          } else if (this.editPara.suitScopeType == "BRAND") {
            this.brandIds = suitResourceList;
          }
          if (this.editPara.bonusSupplierBearVOList && this.editPara.bonusSupplierBearVOList.length > 0) {
            let bonusSupplierBearVOList = [];
            for (let i = 0; i < this.editPara.bonusSupplierBearVOList.length; i++) {
              // bonusSupplierBearVOList.push(this.editPara.bonusSupplierBearVOList[i].saleBatchNo);
              bonusSupplierBearVOList.push(this.editPara.bonusSupplierBearVOList[i].goodsCodeSale + '-' + this.editPara.bonusSupplierBearVOList[i].saleBatchNo);

            }
            console.log('bonusSupplierBearVOList', bonusSupplierBearVOList);
            this.saleBatchNoList = bonusSupplierBearVOList;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getChannelList();
    this.getBrandList();
    this.getCatList();
    this.getSuitSceneList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getCouponDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    this.effectDate = "";
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
        sList = [];
      }
      this.getCouponDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
      this.goodsSnsList = [];
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.box {
  display: inline-block;
}

.flex {
  display: flex;
  width: 320px;
  justify-content: space-between;
  align-items: center;
}

.inputNumberW {
  width: 80px !important;
}

.inputW {
  width: 400px !important;
}

.tableW {
  width: 600px;
  padding-left: 60px;
  margin: 10px 0px 20px;
}

.textarea {
  width: 400px !important;
  height: 200px;

  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}
</style>
